import { defineComponent as _defineComponent } from 'vue'
import ProductFact from '@/ui/views/product-details/ProductFact.vue';
import SizeAndMeasurements from '@/ui/views/product-details/product-facts/SizeAndMeasurements.vue';
import EnvironmentalProductInformation from '@/ui/views/product-details/product-facts/EnvironmentalProductInformation.vue';
import { computed } from 'vue';
import { TabEnum } from '@/ui/shared/Tabs.vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFactsB2C',
  props: {
    sparePartCategories: null
  },
  setup(__props: any) {

const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const borderColor = computed<OpacityFunction>(() => store.getters['app/borderColor']);
const product = computed<PrivateProductViewModel>(() => store.getters['catalog/product']);
const selectedVariant = computed<PrivateVariantViewObject>(() => store.getters['catalog/selectedVariant']);



const sparepartsId = TabEnum.Spareparts;

return { __sfc: true,theme, borderColor, product, selectedVariant, sparepartsId, ProductFact, SizeAndMeasurements, EnvironmentalProductInformation }
}

})